import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { gameService } from '@/services/game';
import { computed } from 'vue';

export function useGameVariantList() {
    const crudAction = useCrudActions();

    const { list, total, fetchList } = useBaseListView({ request: gameService.variant.list });

    const variantNameMap = computed(() => new Map(list.value.map(item => [item.id, item.name] as [number, string])));
    const variantOptions = computed(() => list.value.map(item => ({ label: item.name, value: item.id })));

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: gameService.variant.remove,
            onSuccess: () => fetchList()
        }),
        enable: crudAction.confirmAndEnable({
            request: gameService.variant.enable,
            onSuccess: () => fetchList()
        }),
        disable: crudAction.confirmAndDisable({
            request: gameService.variant.disable,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, variantOptions, variantNameMap, actions };
}
